import type { SupportedLocale } from '../i18n';
import type { Order } from '../types/order';
import { buildOrderDeliveryDisplay, type OrderDeliveryDisplay } from './order-delivery-display';

export type OrderFulfillmentDisplay =
  | { readonly method: 'pickup'; readonly name: string; readonly details: string }
  | { readonly method: 'delivery'; readonly delivery: OrderDeliveryDisplay };

export function buildOrderFulfillmentDisplay(
  order: Order,
  locale: SupportedLocale,
): OrderFulfillmentDisplay {
  if (order.delivery_method === 'pickup') {
    return {
      method: 'pickup',
      name: order.pickup_place_name_snapshot ?? '',
      details: order.pickup_place_details_snapshot ?? '',
    };
  }
  return { method: 'delivery', delivery: buildOrderDeliveryDisplay(order, locale) };
}
